import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AdminComponent } from './admin.component';
import { ReportManagementComponent } from './report-management/report-management.component';
import { ReportdashboardService } from '../services/reportdashboard.service';
import { UserManagementComponent } from './user-management/user-management.component';
import { LookupManagementComponent } from './lookup-management/lookup-management.component';
import { ReportsDashboardComponent } from './reports-dashboard/reports-dashboard.component';
import { DashboardComponent } from './reports-dashboard/dashboard/dashboard.component';
import { CustomReportsComponent } from './reports-dashboard/custom-reports/custom-reports.component';

const routes: Routes = [
  {
    path: '',
    component: AdminComponent,
    children: [
      { path: 'report-management', component: ReportManagementComponent },
      { path: 'user-management', component: UserManagementComponent },
      { path: 'lookup-management', component: LookupManagementComponent },
      { path: 'report-analytics', component: CustomReportsComponent },
      { path: 'dashboard', component: DashboardComponent }
    ]
  }
];

// , { path: 'reports', component: ReportsComponent }

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [ReportdashboardService]
})
export class AdminRoutingModule {}



// WEBPACK FOOTER //
// ./src/app/admin/admin-routing.module.ts